import React from 'react';
import { withStyles } from "@material-ui/core/styles";
import { CircularProgress } from '@material-ui/core';
import { FIELD_INCORRECT_DATA_VALIDATION } from '../../../../utils/CssConstants';

const styles = {
    campaignListTDataRow: {
        display: 'flex',
        background: '#EDEEF7',
        border: '1px solid #000000',
        boxSizing: 'border-box',
        borderRadius: 10,
        padding: '15px 30px',
        width: '100%',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 10
    },
    fieldError: FIELD_INCORRECT_DATA_VALIDATION,
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '80vh',
        width: '100%',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
    },
    errorContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        width: '100%',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 20,
        color: '#666'
    },
    tableBody: {
        width: '100%',
        position: 'relative',
        minHeight: '400px'
    },
    campaingListData: {
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 20,
        padding: '5px 10px',
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        wordBreak: 'break-word'
    },
    smallSpace: {
        flex: 1
    },
    mediumSpace: {
        flex: 3
    },
    mediumSpaceTwo: {
        flex: 4
    },
    largeSpace: {
        flex: 7
    },
    red: {
        color: 'rgba(200, 55, 104, 1)',
    },
}

const TableData = ({ classes, data, loading, error, onRefresh }) => {
    console.log('TableData received props:', { data, loading, error });
    
    // Ensure data is an array and not null/undefined
    const tableData = Array.isArray(data) ? data : [];
    console.log('Processed tableData:', tableData);

    if (loading) {
        return (
            <tbody className={classes.tableBody}>
                <tr>
                    <td colSpan="5" className={classes.loadingContainer}>
                        <CircularProgress size={80} />
                    </td>
                </tr>
            </tbody>
        );
    }

    if (error) {
        return (
            <tbody className={classes.tableBody}>
                <tr>
                    <td colSpan="5" className={classes.errorContainer}>
                        {error}
                        <button onClick={onRefresh} style={{ marginLeft: '10px' }}>Retry</button>
                    </td>
                </tr>
            </tbody>
        );
    }

    if (!tableData || tableData.length === 0) {
        console.log('No data to display');
        return (
            <tbody className={classes.tableBody}>
                <tr>
                    <td colSpan="5" className={classes.errorContainer}>
                        No data available
                    </td>
                </tr>
            </tbody>
        );
    }

    return (
        <tbody className={classes.tableBody}>
            {tableData.map((coupon, index) => {
                console.log('Rendering coupon:', coupon);
                return (
                    <tr key={index} className={classes.campaignListTDataRow}>
                        <td className={`${classes.campaingListData} ${classes.mediumSpaceTwo}`}>{coupon.coupon_code || 'N/A'}</td>
                        <td className={`${classes.campaingListData} ${classes.mediumSpaceTwo}`}>{coupon.coupon_amount || '0'}</td>
                        <td className={`${classes.campaingListData} ${classes.mediumSpace} ${coupon.status === 'Active' ? classes.statusActive : ''}`}>
                            {coupon.status || 'N/A'}
                        </td>
                        <td className={`${classes.campaingListData} ${classes.mediumSpace}`}>
                            {coupon.creation_date ? new Date(coupon.creation_date).toLocaleDateString() : 'N/A'}
                        </td>
                    </tr>
                );
            })}
        </tbody>
    );
};

export default withStyles(styles)(TableData);